var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 573,
    viewBox: "0 0 600 573",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.445 319.998L514 233L398.3 353.934L285.182 466L236 412.673L310.851 338.372L329.445 319.998Z",
    fill: "#55C6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240 504.23L289.505 552L447.366 398.161L568.42 398.161C585.861 398.161 600 384.022 600 366.58V366.58C600 349.139 585.861 335 568.42 335L412.901 335L240 504.23Z",
    fill: "#51E5A5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.201 380L82 333.318L186.2 232.4L305.172 111L364 164.393L282.603 232.4L130.201 380Z",
    fill: "#51E5A5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299.957 545.734V545.734C284.687 560.793 259.931 560.793 244.662 545.734L232.813 534.048L231.299 397.717L94.5747 397.717L86.6754 389.926C71.406 374.868 71.406 350.452 86.6754 335.394V335.394L298.327 335.453L299.957 545.734Z",
    fill: "#F4E12F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M118.258 397.716L94.5614 397.718L86.6621 389.928C71.3928 374.869 71.3928 350.454 86.6621 335.395L181.453 335.393L118.258 397.716Z",
    fill: "#24B57E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M480.657 178L529 226.875L424.494 332.53L359.251 386L315 332.53L391.728 258.03L480.657 178Z",
    fill: "#55C6FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M356 68.9201L308.631 21L167.462 169.767L34.1164 169.767C15.2744 169.767 1.645e-05 185.042 1.52571e-05 203.884V203.884C1.40642e-05 222.726 15.2745 238 34.1164 238L181.603 238L356 68.9201Z",
    fill: "#55C6FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M523.181 237.607V237.607C538.451 222.548 538.451 198.133 523.182 183.074L511.333 171.388L376.988 169.896L373.095 35.0568L365.195 27.2665C349.926 12.2077 325.169 12.2077 309.9 27.2665V27.2665L309.96 235.999L523.181 237.607Z",
    fill: "#9A71FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M373.09 58.4266L373.092 35.0567L365.193 27.2664C349.923 12.2076 325.167 12.2076 309.897 27.2664L309.895 120.75L373.09 58.4266Z",
    fill: "#584DE2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M491.578 175.284L515.275 175.282L523.174 183.072C538.444 198.131 538.444 222.546 523.174 237.605L428.384 237.607L491.578 175.284Z",
    fill: "#584DE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.87c296e3b7b31244becb380402c5da67.svg";
export { ForwardRef as ReactComponent };